import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './support-share.component.html';
var SupportShareComponent = (function () {
    function SupportShareComponent() {
        this.hashInShareUrl = true;
        this.isShareLinkExpanded = false;
        this.expanded = false;
    }
    SupportShareComponent.prototype.toggle = function () {
        this.expanded = !this.expanded;
        if (this.isShareLinkExpanded) {
            this.isShareLinkExpanded = false;
        }
    };
    SupportShareComponent.prototype.toggleShareLinkState = function () {
        this.isShareLinkExpanded = !this.isShareLinkExpanded;
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportShareComponent.prototype, "itemLink", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportShareComponent.prototype, "itemUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SupportShareComponent.prototype, "hashInShareUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportShareComponent.prototype, "pdfUrl", void 0);
    SupportShareComponent = __decorate([
        Component({
            selector: 'supportShare',
            template: template,
        })
    ], SupportShareComponent);
    return SupportShareComponent;
}());
export { SupportShareComponent };
